import { FlightState } from "@/lib/redux/features/flight/type"
import dayjs from "dayjs"

export const sortLatest = (state: FlightState, flightId1: any, flightId2: any) => {
  const flightsResult = state.flightsResult
  const segment1 = flightsResult.flights[flightId1].segments[0]
  const segment2 = flightsResult.flights[flightId2].segments[0]
  return dayjs(segment2.startTime).valueOf() - dayjs(segment1.startTime).valueOf()
}